<template>
  <div>
    <frame-form ref="PrjBonusForm" componentParam="prj_bonus_form" :init-data="bonusData"></frame-form>
    <el-row>
      <el-col :span="5" >
        <el-form-item label="人工总费用：" label-width="130px" required>
          <el-input-number v-model="bonusData.total_labor_cost" :min="0" clearable @change="getTotalProfit"
          :disabled="approve_status !== '待提交' && approve_status !== '已驳回'"
          ></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="4" >
        <el-form-item label="总毛利：" label-width="130px">{{bonusData.total_profit}}
        </el-form-item>
      </el-col>
    </el-row>
  </div>
  <el-row class="box">
    <el-col :span="3">项目成员</el-col>
    <el-col :span="3">盈余百分比(%)</el-col>
    <el-col :span="3">提成金额</el-col>
    <el-col :span="9">备注</el-col>
    <el-col :span="3" v-if="approve_status !== '待提交'">审批状态</el-col>
    <el-col :span="2" v-if="approve_status === '已驳回' || approve_status === '已审批' ">审批人</el-col>
    <el-col :span="1" v-if="approve_status === '已驳回' || approve_status === '待提交'">
      <el-button type="warning" @click="addBonusRow(1)"
                 style="font-size: 20px;position: absolute;top: 2px;right : 0;">+</el-button>
    </el-col>
  </el-row>

  <div style="max-height:450px;overflow-x: hidden;overflow-y: auto;width: 98%;">
    <el-row v-for="bonus in bonusData.bonus_list" style="margin-top:10px; margin-bottom: 10px;" gutter="5" >
      <el-col :span="3">
        <el-select v-model="bonus.bonus_user_id" clearable :disabled="approve_status === '待审批' || approve_status === '已审批'">
          <el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-col>
      <el-col :span="3" style="text-align: center">
        <el-input-number style="width: 100%" v-model="bonus.percentage" :min="0" :max="100" @change="getAmount(bonus)"
                         :disabled="approve_status === '待审批' || approve_status === '已审批'">
          <template #suffix>
            <span>%</span>
          </template>
        </el-input-number>
      </el-col>
      <el-col :span="3" style="text-align: center" >
        <el-input-number style="width: 100%" :min="0" v-model="bonus.amount" disabled>
        </el-input-number>
      </el-col>
      <el-col :span="9" style="text-align: center" >
        <el-input v-model="bonus.remark" :disabled="approve_status === '待审批' || approve_status === '已审批'">
        </el-input>
      </el-col>
      <el-col :span="3" style="text-align: center;padding-top: 5px" v-if="approve_status !== '待提交'">
        <el-text size="large">{{bonus.approve_status_name}}</el-text>
      </el-col>
      <el-col :span="2" style="text-align: center;padding-top: 5px" v-if="approve_status === '已驳回' || approve_status === '已审批'">
        <el-text size="large">{{bonus.approve_user_name}}</el-text>
      </el-col>
      <el-col :span="1" v-if="approve_status === '已驳回' || approve_status === '待提交'">
        <div  class="close" @click="removeBonusRow(bonus.nanoid)"
              v-if="bonusData.bonus_list.length > 1">
          <el-icon>
            <ElIconClose></ElIconClose>
          </el-icon>
        </div>
      </el-col>
    </el-row>
  </div>
  <el-row style="margin-top:20px;width: 80%;">
    <el-col :span="24" style="text-align: center">
      <el-button type="primary" @click="submitBonus" :disabled="approve_status !== '待提交' && approve_status !== '已驳回'">提交</el-button>
      <el-button type="primary" @click="submitApproveBonus" :disabled="approve_status !== '待审批'">通过</el-button>
      <el-button type="warning" @click="submitRejectedBonus" :disabled="approve_status !== '待审批'">驳回</el-button>
    </el-col>
  </el-row>

</template>

<script>

import {nanoid} from "nanoid";
import {ElMessage, ElMessageBox} from "element-plus";

export default {
  name: 'ProjectBonus',
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      bonusData: {
        bonus_list:[]
      },
      userList:[],
      approve_status:'',
    }
  },

  created() {
    this.getBonusData();
  },

  methods: {
    async getBonusData() {
      this.bonusData = await this.$http('prjBonusService.getProjectById', {project_id:this.parentData.id});
      this.approve_status = await this.$http('prjBonusService.getApproveStatus', {project_id:this.parentData.id});
      await this.$refs.PrjBonusForm.initForm();
      await this.getBonusList();
    },

    //获取提成数据
    async getBonusList(){
      this.bonusData.bonus_list = await this.$http('prjBonusService.getBonusAll', {project_id:this.parentData.id});
      await this.loadUsers();
      this.getTotalProfit();
      if (this.bonusData.bonus_list.length === 0){
        this.addBonusRow(this.userList.length)
      } else {
        for (const item of this.bonusData.bonus_list) {
          item.percentage = item.amount / this.bonusData.total_profit * 100;
          item.nanoid = nanoid();
        }
      }
    },

    //获取总毛利
    getTotalProfit() {
      if (this.bonusData.total_labor_cost){
        this.bonusData.total_profit = this.bonusData.total_income - this.bonusData.total_cost - this.bonusData.total_labor_cost;
      } else {
        this.bonusData.total_profit = this.bonusData.total_income - this.bonusData.total_cost
      }

    },

    //获取项目成员
    async loadUsers() {
      this.userList = await this.$http('prjProjectService.getMemberAll', {project_id:this.parentData.id});
    },

    //添加提成行
    addBonusRow(cnt) {
      for(var i=0;i<cnt;i++){
        this.bonusData.bonus_list.push({
          nanoid: nanoid(),
          approve_status:''
        })
      }
    },

    //删除提成行
    removeBonusRow(nanoid) {
      let index = this.bonusData.bonus_list.findIndex(item => item.nanoid === nanoid);
      this.bonusData.bonus_list.splice(index, 1);
    },

    //通过百分比获取金额
    async getAmount(bonus) {
      if (!bonus.percentage) {
        bonus.amount = 0;
        return;
      }
      // if (!this.bonusData.total_labor_cost){
      //   this.$message.warning('请先填写人工总费用')
      //   bonus.percentage = 0;
      //   return;
      // }
      bonus.amount = parseFloat((bonus.percentage * this.bonusData.total_profit / 100).toFixed(3));
    },

    //提成保存
    submitBonus() {
      ElMessageBox.confirm(
          '你是否要提交当前页面的提成数据信息？',
          '提成提交',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        await this.$http('prjBonusService.submitBonus', this.bonusData);
        ElMessage({
          type: 'success',
          message: '操作成功，已保存',
        })
        await this.getBonusData()
      })
    },

    //提成审批通过
    submitApproveBonus() {
      ElMessageBox.confirm(
          '是否确定审批通过？',
          '提成审批',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        await this.$http('prjBonusService.submitApproveBonus', this.bonusData);
        ElMessage({
          type: 'success',
          message: '操作成功，已保存',
        })
        await this.getBonusData();
      })
    },

    //提成审批驳回
    submitRejectedBonus() {
      ElMessageBox.confirm(
          '是否确定审批驳回？',
          '提成审批',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        await this.$http('prjBonusService.submitRejectedBonus', this.bonusData);
        ElMessage({
          type: 'success',
          message: '操作成功，已保存',
        })
        await this.getBonusData();
      })
    }

  }
}

</script>

<style  scoped>

.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
  width: 98%;
}

.close {
  position: absolute;
  top: 5px;
  right: 20px;
  font-size: 15px;
  cursor: pointer;
}



</style>
